export const GET_PRODUCT_STUDENTS_REQUEST = 'GET_PRODUCT_STUDENTS_REQUEST';
export const GET_PRODUCT_STUDENTS_SUCCESS = 'GET_PRODUCT_STUDENTS_SUCCESS';
export const GET_PRODUCT_STUDENTS_FAILURE = 'GET_PRODUCT_STUDENTS_FAILURE';

export const getProductStudents = productId =>
    ({ type: GET_PRODUCT_STUDENTS_REQUEST, productId });

export const getProductStudentsSuccess = data =>
    ({ type: GET_PRODUCT_STUDENTS_SUCCESS, data });

export const getProductStudentsFailure = () =>
    ({ type: GET_PRODUCT_STUDENTS_FAILURE });

export const DOWNLOAD_STUDENT_ROLL_REQUEST = 'DOWNLOAD_STUDENT_ROLL_REQUEST';
export const DOWNLOAD_STUDENT_ROLL_SUCCESS = 'DOWNLOAD_STUDENT_ROLL_SUCCESS';
export const DOWNLOAD_STUDENT_ROLL_FAILURE = 'DOWNLOAD_STUDENT_ROLL_FAILURE';

export const downloadStudentRoll = (students, isStudentRollDownloaded) =>
    ({ type: DOWNLOAD_STUDENT_ROLL_REQUEST, students, isStudentRollDownloaded });

export const downloadStudentRollSuccess = (downloadUrl, isStudentRollDownloaded) => {
    window.location.href = downloadUrl;
    return ({ type: DOWNLOAD_STUDENT_ROLL_SUCCESS, isStudentRollDownloaded });
};

export const downloadStudentRollFailure = () => ({ type: DOWNLOAD_STUDENT_ROLL_FAILURE });

export const FILTER_VALUE_CLEARED = 'FILTER_VALUE_CLEARED';
export const FILTER_VALUE_CHANGED = 'FILTER_VALUE_CHANGED';
export const UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM';
export const SORT_STUDENT_LIST = 'SORT_STUDENT_LIST';
export const RETRIEVE_SELECTED_STUDENT = 'RETRIEVE_SELECTED_STUDENT';

export const clearFilterValue = () => ({ type: FILTER_VALUE_CLEARED });

export const changeFilterValue = (collectionName, key) => ({ type: FILTER_VALUE_CHANGED, collectionName, key });

export const updateSearchTerm = searchTerm => ({ type: UPDATE_SEARCH_TERM, searchTerm });

export const sortStudentList = columnToSort => ({ type: SORT_STUDENT_LIST, columnToSort });

export const retrieveSelectedStudents = selectedStudentsProfileId => ({
    type: RETRIEVE_SELECTED_STUDENT,
    selectedStudents: selectedStudentsProfileId
});

export const PRINT_SIGN_IN_CARD_REQUEST = 'PRINT_SIGN_IN_CARD_REQUEST';
export const PRINT_SIGN_IN_CARD_SUCCESS = 'PRINT_SIGN_IN_CARD_SUCCESS';
export const PRINT_SIGN_IN_CARD_FAILURE = 'PRINT_SIGN_IN_CARD_FAILURE';

export const printSignInCard = (productId, studentSignInCardsData) =>
    ({ type: PRINT_SIGN_IN_CARD_REQUEST, isSignInCardDownloaded: false, productId, studentSignInCardsData });

export const printSignInCardSuccess = (downloadUrl, isSignInCardDownloaded) => {
    window.location.href = downloadUrl;
    return ({ type: PRINT_SIGN_IN_CARD_SUCCESS, downloadUrl, isSignInCardDownloaded });
};

export const printSignInCardFailure = isSignInCardDownloaded =>
    ({ type: PRINT_SIGN_IN_CARD_FAILURE, isSignInCardDownloaded });

export const ADD_STUDENT_OPEN_MODAL_REQUEST = 'ADD_STUDENT_OPEN_MODAL_REQUEST';
export const ADD_STUDENT_CLOSE_MODAL_REQUEST = 'ADD_STUDENT_CLOSE_MODAL_REQUEST';
export const ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST = 'ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST';

export function openAddStudentModal() {
    return {
        type: ADD_STUDENT_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddStudentConfirmationModal: false
    };
}

export function addAnotherStudentModal() {
    return {
        type: ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddStudentConfirmationModal: false
    };
}

export function closeAddStudentModal() {
    return {
        type: ADD_STUDENT_CLOSE_MODAL_REQUEST,
        showModal: false
    };
}

export const ADD_STUDENT_REQUEST = 'ADD_STUDENT_REQUEST';
export const ADD_STUDENT_SUCCESS = 'ADD_STUDENT_SUCCESS';
export const ADD_STUDENT_FAILURE = 'ADD_STUDENT_FAILURE';

export const addStudent = student =>
    ({ type: ADD_STUDENT_REQUEST, student, isSaveInProgress: true });

export function addStudentSuccess(userProfileId) {
    return {
        type: ADD_STUDENT_SUCCESS,
        userProfileId,
        isSaveInProgress: false,
        showAddStudentConfirmationModal: true
    };
}

export function addStudentFailure(isServerError, addStudentValidationMessage, showAddStudentValidationModal = true) {
    return {
        type: ADD_STUDENT_FAILURE,
        addStudentValidationMessage,
        showAddStudentValidationModal,
        isSaveInProgress: false,
        isServerError
    };
}

export const CLOSE_ADD_STUDENT_VALIDATION_MODAL = 'CLOSE_ADD_STUDENT_VALIDATION_MODAL';

export function closeAddStudentValidationModal() {
    return {
        type: CLOSE_ADD_STUDENT_VALIDATION_MODAL,
        showAddStudentValidationModal: false
    };
}

export const ADD_STUDENT_GET_GROUPS_REQUEST = 'ADD_STUDENT_GET_GROUPS_REQUEST';
export const ADD_STUDENT_GET_GROUPS_SUCCESS = 'ADD_STUDENT_GET_GROUPS_SUCCESS';
export const ADD_STUDENT_GET_GROUPS_FAILURE = 'ADD_STUDENT_GET_GROUPS_FAILURE';

export const getClassroomGroups = classroomId =>
    ({ type: ADD_STUDENT_GET_GROUPS_REQUEST, classroomId, isFetchingGroupsAddStudent: true, fetchedGroupsAddStudent: false });

export const getClassroomGroupsSuccess = classroomGroups =>
    ({ type: ADD_STUDENT_GET_GROUPS_SUCCESS, classroomGroups, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: true });

export const getClassroomGroupsFailure = () =>
    ({ type: ADD_STUDENT_GET_GROUPS_FAILURE, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: false });

export const BULK_PASSWORD_CHANGE_STUDENTS_REQUEST = 'BULK_PASSWORD_CHANGE_STUDENTS_REQUEST';
export const BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS = 'BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS';
export const BULK_PASSWORD_CHANGE_STUDENTS_FAILURE = 'BULK_PASSWORD_CHANGE_STUDENTS_FAILURE';

export const bulkPasswordChangeStudents = (selectedStudents, newPassword) =>
    ({ type: BULK_PASSWORD_CHANGE_STUDENTS_REQUEST, selectedStudents, newPassword, disableConfirmationButton: true });

export const bulkPasswordChangeStudentsSuccess = () =>
    ({ type: BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS, isBulkPasswordChangeModalOpen: false, disableConfirmationButton: false, bulkPasswordValue: '' });

export const bulkPasswordChangeStudentsFailure = () =>
    ({ type: BULK_PASSWORD_CHANGE_STUDENTS_FAILURE, disableConfirmationButton: false, bulkPasswordValue: '' });

export const BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE = 'BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE';

export const bulkPasswordChangeStudentsSetValue = newPassword =>
    ({ type: BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE, bulkPasswordValue: newPassword });

export const OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL = 'OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL';

export const openBulkPasswordChangeStudentsModal = () =>
    ({ type: OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL, isUserOperationModalOpen: true, disableConfirmationButton: false, bulkPasswordValue: '', operationType: 'bulkPasswordChange' });

export const UNASSIGN_STUDENTS_REQUEST = 'UNASSIGN_STUDENTS_REQUEST';
export const UNASSIGN_STUDENTS_SUCCESS = 'UNASSIGN_STUDENTS_SUCCESS';
export const UNASSIGN_STUDENTS_FAILURE = 'UNASSIGN_STUDENTS_FAILURE';

export const unassignStudents = (selectedStudents, productId) =>
    ({ type: UNASSIGN_STUDENTS_REQUEST, selectedStudents, productId, disableConfirmationButton: true });

export const unassignStudentsSuccess = () =>
    ({ type: UNASSIGN_STUDENTS_SUCCESS, isUserOperationModalOpen: false, disableConfirmationButton: false });

export const unassignStudentsFailure = () =>
    ({ type: UNASSIGN_STUDENTS_SUCCESS, disableConfirmationButton: false });

export const OPEN_UNASSIGN_STUDENTS_MODAL = 'OPEN_UNASSIGN_STUDENTS_MODAL';
export const CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL = 'CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL';

export const openUnAssignStudentsModal = () =>
    ({ type: OPEN_UNASSIGN_STUDENTS_MODAL, isUserOperationModalOpen: true, operationType: 'unassignUser' });

export const closeStudentsOperationConfirmationModal = () =>
    ({ type: CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL, refreshStudentList: true, selectedStudents: [], operationType: '' });

export const OPEN_DELETE_USER_MODAL = 'OPEN_DELETE_USER_MODAL';

export const openDeleteUserConfirmation = () =>
    ({ type: OPEN_DELETE_USER_MODAL, isUserOperationModalOpen: true, operationType: 'deleteUser' });

export const DELETE_STUDENT_REQUEST = 'DELETE_STUDENT_REQUEST';
export const DELETE_STUDENT_SUCCESS = 'DELETE_STUDENT_SUCCESS';
export const DELETE_STUDENT_FAILURE = 'DELETE_STUDENT_FAILURE';

export const deleteStudentRequest = (userProfileIds, productId) =>
    ({ type: DELETE_STUDENT_REQUEST, disableConfirmationButton: true, userProfileIds, productId, operationType: 'deleteUser' });

export const deleteStudentSuccess = response =>
    ({ type: DELETE_STUDENT_SUCCESS,
        isUserOperationModalOpen: false,
        disableConfirmationButton: false,
        isPartialDelete: response.isPartialDelete,
        deletedStudentsCount: response.noOfStudentsDeleted,
        selectedStudents: []
    });

export const deleteStudentFailure = () =>
    ({ type: DELETE_STUDENT_FAILURE, disableConfirmationButton: false });

export const CLEAR_OPERATION_TYPE = 'CLEAR_OPERATION_TYPE';

export const clearOperationTypeRequest = () =>
    ({ type: CLEAR_OPERATION_TYPE });

export const DOWNLOAD_STUDENTS_SIGN_IN_CARD = 'DOWNLOAD_STUDENTS_SIGN_IN_CARD';

export const downloadStudentsSignInCards = () =>
    ({ type: DOWNLOAD_STUDENTS_SIGN_IN_CARD, isUserOperationModalOpen: true, operationType: 'downloadSignInCard' });

export const SHOW_HIDE_SIGNIN_CARD_MODAL = 'SHOW_HIDE_SIGNIN_CARD_MODAL';

export const showHideSignInCardModalRequest = status =>
    ({ type: SHOW_HIDE_SIGNIN_CARD_MODAL, showHideSignInCardModal: status });



// WEBPACK FOOTER //
// ./app/containers/student-roll/actions.js